<template>
  <div class="app-container-v2 table-container-v2">
    <div class="title-box">
      <div class="title-left">
        <el-input class="input-v2 prefix-primary-color" placeholder="姓名 联系电话" suffix-icon="el-icon-search"></el-input>
        <el-checkbox class="ml16 checkbox-v2" v-model="checkNoCefirmFlag" @change="checkNoCefirm">未确认人员</el-checkbox>
      </div>
      <div class="title-right">
        <!--<el-button type="primary" class="button-v2" @click="addUpload=true">新增</el-button>-->
        <el-button type="primary" class="button-v2" @click="handleSentEmail">发送邮件</el-button>
        <el-button type="primary" class="button-v2" @click="exportExcel">导出</el-button>
        <el-button plain class="button-v2" @click="goBack">返回</el-button>
      </div>
    </div>
    <div class="pl24 pr24 pt24" style="font-size: 14px">
      <div>年-月/批次号：{{importDate.substring(0,7)}}/{{branchId}}</div>
      <div class="flex jbetween mt10">
        <span>欠款总金额：{{sum.owedAmount}}元</span>
        <span>已确认额：{{sum.repaymentAmount}}元</span>
        <span>欠款总人数：{{sum.repaymentNum}}人</span>
        <span>已确认人数：{{sum.sentNum}}人</span>
      </div>
    </div>
    <div class="table-body flex vertical" style="height: calc(100vh - 234px);">
      <air-table
        ref="airTable"
        class="table-v2"
        :show-checkbox="true"
        align="center"
        :columns="columns"
        :data="tableData"
        @checkbox-change="handleSelectionChange"
        @checkbox-all="handleSelectionChange"
        @change-filter="changeFilter"
      >
        <template #operation="{ row }">
          <div class="flex center">
            <span class="text-button" @click="handleDelete(row)">删除</span>
          </div>
        </template>
      </air-table>
      <bsp-pagination :pager-config.sync="queryParams" @page-change="pageChange" @page-size-change="pageSizeChange" show-page-size />
    </div>
    <!-- 新增弹框 -->
    <el-dialog
      class="modal-v2 has-padding"
      ref="cusPaysetDialog"
      v-dialogDrag
      title="添加雇员欠款信息"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="addUpload"
      v-loading="loading"
      append-to-body
      width="700px"
    >
      <el-form class="form-v2" ref="form" :model="form" label-width="100px">
        <el-form-item label="雇员编号" prop="empNo">
          <el-input class="input-v2" v-model="form.empNo"></el-input>
        </el-form-item>
        <el-form-item label="雇员姓名" prop="empName">
          <el-input class="input-v2" v-model="form.empName"></el-input>
        </el-form-item>
        <el-form-item label="雇员证件号" prop="idCard">
          <el-input class="input-v2" v-model="form.idCard"></el-input>
        </el-form-item>
        <el-form-item label="雇员邮箱" prop="empEmail">
          <el-input class="input-v2" v-model="form.empEmail"></el-input>
        </el-form-item>
        <el-form-item label="还款金额" prop="repaymentAmount">
          <el-input class="input-v2" v-model="form.repaymentAmount"></el-input>
        </el-form-item>
        <el-form-item label="还款时间" prop="repaymentDate">
          <el-input class="input-v2" v-model="form.repaymentDate"></el-input>
        </el-form-item>
        <el-form-item label="公司开户名" prop="companyAccountName">
          <el-input class="input-v2" v-model="form.companyAccountName"></el-input>
        </el-form-item>
        <el-form-item label="公司开户行" prop="companyBank">
          <el-input class="input-v2" v-model="form.companyBank"></el-input>
        </el-form-item>
        <el-form-item label="公司银行账号" prop="companyBankNo">
          <el-input class="input-v2" v-model="form.companyBankNo"></el-input>
        </el-form-item>
        <el-form-item label="汇款摘要" prop="remitAbstract">
          <el-input class="input-v2" v-model="form.remitAbstract"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input class="textarea-v2" type="textarea" v-model="form.remark"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="w100 flex jbetween acenter">
        <el-button class="button-v2" plain @click="addUpload = false">取消</el-button>
        <el-button class="button-v2" type="primary">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import { sentEmail, exportExcel } from "@/api/tesla/debtDetails.js";
  import {
    getloadTaxData
  } from "@/api/tesla/debtManagement.js";
  import {downloadFile} from "@/util/util";
  import { validatenull } from '@/util/validate';
  
  export default {
    name: 'DebtDetails',
    created() {
      this.getColumns()
      this.getData()
    },
    data() {
      return {
        branchId:this.$route.query.batchId,
        importDate:this.$route.query.importDate,
        queryParams: {
          page: 1,
          limit: 20,
          total: 0
        },
        change:'1',
        addUpload: false,
        checkNoCefirmFlag: false,
        form:{
          companyAccountName: "",
          companyBank: "",
          companyBankNo: "",
          empEmail: "",
          empName: "",
          empNo: "",
          id: "",
          idCard: "",
          remark: "",
          remitAbstract: "",
          repaymentAmount: "",
          repaymentDate: "",
          reserveColumnOne: '',
          reserveColumnThree: '',
          reserveColumnTwo: '',
          rowId: '',
          sentnums: '',
          status: "",
        },
        noCefirm: [],
        sum: '',
        columns: [],
        tableData: [],
        multipleSelection: [],
        statusOptions: [
          { codeItemId: 0, codeItemName: '未发送' },
          { codeItemId: 1, codeItemName: '已发送未确认' },
          { codeItemId: 2, codeItemName: '已确认' }
        ]
      }
    },
    methods: {
      goBack() {
        this.$router.go(-1)
      },
      pageChange({ type, currentPage, pageSize }) {
        if (type == 'size') {
          this.queryParams.page = 1;
        }
        this.getData();
      },
      // 分页输入框回车，调接口
      pageSizeChange(val) {
        this.queryParams = Object.assign(val);
        this.getData();
      },
      changeFilter(e) {
        this.queryParams = {...this.queryParams, ...e.filterData};
        this.getData();
      },
      handleSelectionChange({records}) {
        this.multipleSelection = records;
      },
      getColumns() {
        this.columns = [
          { title: '雇员编号', field: 'empNo', minWidth: 140, filterType: 'input' },
          { title: '雇员姓名', field: 'empName', minWidth: 140, filterType: 'input' },
          { title: '还款金额', field: 'repaymentAmount', minWidth: 140, filterType: 'input',
            formatFunction(row) {
              return row.repaymentAmount + '元'
            }
          },
          { title: '状态', field: 'status', minWidth: 140, filterType: 'select', filterOptions: this.statusOptions },
          { title: '雇员证件号', field: 'idCard', minWidth: 140, filterType: 'input' },
          { title: '雇员邮箱', field: 'empEmail', minWidth: 140, filterType: 'input' },
          { title: '发送次数', field: 'sentnums', minWidth: 140, filterType: 'input' },
          { title: '还款时间', field: 'repaymentDate', minWidth: 140, filterType: 'input' },
          { title: '公司开户名', field: 'companyAccountName', minWidth: 140, filterType: 'input' },
          { title: '公司银行账号', field: 'companyBankNo', minWidth: 140, filterType: 'input' },
          { title: '公司开户行', field: 'companyBank', minWidth: 140, filterType: 'input' },
          { title: '汇款摘要', field: 'remitAbstract', minWidth: 140, filterType: 'input' },
          { title: '备注', field: 'remark', minWidth: 140, filterType: 'input' },
          { title: '预留列1', field: 'reserveColumnOne', minWidth: 140, filterType: 'input' },
          { title: '预留列2', field: 'reserveColumnTwo', minWidth: 140, filterType: 'input' },
          { title: '预留列3', field: 'reserveColumnThree', minWidth: 140, filterType: 'input' }
        ]
      },
      // 初始化数据
      getData() {
        let params = {
          pageNum: '2',
          ...this.queryParams,
          batchId:this.$route.query.batchId
        }
        console.log(params, 'params')
        getloadTaxData({
          param: JSON.stringify(params)
        }).then(res=>{
          if(res.data.code ==0 ) {
            this.tableData = res.data.data.dataList
            this.queryParams.total = parseInt(res.data.data.total)
            this.sum = res.data.data.sum
          }
        })
      },
      // 删除
      handleDelete(row) {
    
      },
      checkNoCefirm(val){
        if(val) {
          this.$confirm('如已发送过邮件，本次操作会导致重复发送邮件，是否继续？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            const setRow = this.tableData.filter(item => item.status != '已确认')
            this.$refs.airTable.setCheckbox(setRow, true)
          }).catch(()=>{
            this.checkNoCefirmFlag = false
            this.$refs.airTable.clearCheckbox()
          })
        } else {
          this.$refs.airTable.clearCheckbox()
        }
      },
      // 发送邮件
      handleSentEmail() {
        let params = {};
        if(this.multipleSelection.length > 0) {
          const ids = this.multipleSelection.map(item => item.id);
          params.batchIds = ids.join(',');
          this.confirmSendEmail(params);
        } else {
          this.$confirm('是否发送全部未发送人员?', '提示', {
            type: 'warning'
          }).then(() => {
            params.status = 0;
            params.batchId = this.branchId;
            this.confirmSendEmail(params);
          }).catch(() => {});
        }
      },
      confirmSendEmail(params){
        sentEmail(params).then(res=> {
          if(res.data.code==0){
            this.$confirm('成功发送邮件'+res.data.data+'封!', '邮件发送成功！', {
              confirmButtonText: '完成',
              showCancelButton:false,
              type: 'success',
              showClose:false,
              center: true
            })
            this.checkNoCefirmFlag = false
            this.getData()
          }
        })
      },
      // 导出
      exportExcel() {
        exportExcel(this.branchId).then(res=> {
          downloadFile(res)
        })
      }
    }
  }
</script>
